import ReactApexChart from 'react-apexcharts'

import { numberToBRL } from '~/modules/sales/services'

import { LicenseExtensionPopularityData } from './types'

const COLORS = ['#9333ea', '#3b82f6', '#10b981', '#f59e0b', '#ef4444']

type Props = {
  data: LicenseExtensionPopularityData[]
}

export const LicensePopularityChart: React.FC<Props> = ({ data }) => {
  const filtered = data.filter((d) => d.totalPurchases > 0)

  return (
    <div className='bg-white rounded-xl shadow-md p-6 overflow-hidden'>
      <h2 className='text-lg font-semibold text-gray-700 mb-6'>
        Popularidade dos Pacotes
      </h2>
      <div className='flex flex-col'>
        <div className='flex flex-col md:flex-row items-center mb-6'>
          <div className='w-full md:w-1/2 mb-4 md:mb-0'>
            <ReactApexChart
              type='donut'
              height={280}
              width='100%'
              options={{
                chart: { type: 'donut' },
                labels: filtered.map((d) => d.name),
                colors: COLORS,
                legend: { show: false },
                plotOptions: {
                  pie: {
                    donut: {
                      size: '55%',
                      labels: {
                        show: true,
                        name: { show: true },
                        value: {
                          show: true,
                          formatter: (val) => val + ' compras',
                        },
                        total: {
                          show: true,
                          label: 'Total',
                          formatter: (w) =>
                            w.globals.seriesTotals.reduce(
                              (a: number, b: number) => a + b,
                              0,
                            ) + ' compras',
                        },
                      },
                    },
                  },
                },
                dataLabels: { enabled: false },
              }}
              series={filtered.map((d) => d.totalPurchases)}
            />
          </div>
          <div className='w-full md:w-1/2 flex justify-center'>
            <div className='flex flex-col justify-center space-y-2'>
              {filtered.map((d, i) => (
                <div key={d.extensionId} className='flex items-center'>
                  <div
                    className='w-4 h-4 rounded mr-3 flex-shrink-0'
                    style={{ backgroundColor: COLORS[i] }}
                  />
                  <span className='text-sm text-gray-700'>
                    {d.name}: {d.totalPurchases} compras
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className='mt-6'>
          <table className='min-w-full'>
            <thead>
              <tr>
                <th className='text-left text-xs font-medium text-gray-500 uppercase tracking-wider pb-2'>
                  Pacote
                </th>
                <th className='text-center text-xs font-medium text-gray-500 uppercase tracking-wider pb-2'>
                  Licenças
                </th>
                <th className='text-center text-xs font-medium text-gray-500 uppercase tracking-wider pb-2'>
                  Compras
                </th>
                <th className='text-right text-xs font-medium text-gray-500 uppercase tracking-wider pb-2'>
                  Receita total
                </th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((d) => (
                <tr key={d.extensionId} className='border-t border-gray-200'>
                  <td className='py-2 text-sm text-gray-700'>{d.name}</td>
                  <td className='py-2 text-sm text-center text-gray-700'>
                    {d.licensesAmount}
                  </td>
                  <td className='py-2 text-sm text-center text-gray-700'>
                    {d.totalPurchases}
                  </td>
                  <td className='py-2 text-sm text-right text-gray-700'>
                    {numberToBRL(d.totalRevenue / 100)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
